import AnalyticsHelper from '../../utils/analytics-helper.js';
import CompositeFormField from './composite-field.js';

export default class AddressLookup extends CompositeFormField {
    constructor(parent, el) {
        super(parent, el);
        this.mode = this.el.dataset.mode == 'custom' ? 'custom' : 'standard';
        this.bind();
    }

    bind() {
        this.el.querySelector('.form_field_link').addEventListener('click', (e) => this.search(e));
        this.el.querySelector('.form_field_address_list').addEventListener('click', (e) => (e.target.classList.contains('address_item') ? this.select(e) : null));
    }

    search(e) {
        e.preventDefault();
        const postcode = this.field('postcode');
        const val = postcode.inputs[0].value();

        const url = this.el.dataset.searchUrl;
        const query = val ? `?postcode=${val}` : '';
        postcode.valid().then((v) => {
            if (v) {
                fetch(url + query).then((response) => response.json()).then((data) => this.list(data)).catch((error) => this.fail);
            }
        });

        this.analyticsPush(e, 'find_address');
    }

    list(data) {
        const list = this.field('address_list');
        const options = data.map((a) => `<a class="address_item" href="#" data-moniker="${a.moniker}">${a.partialAddress}</a>`).join('');
        list.el.innerHTML = options;
        this.el.classList.add('form_field_address_list_show');
    }

    select(e) {
        e.preventDefault();
        const { moniker } = e.target.dataset;
        const url = this.el.dataset.getUrl;
        const query = moniker ? `?moniker=${moniker}` : '';

        if (moniker) {
            this.el.classList.remove('form_field_address_list_show');
            fetch(url + query).then((response) => response.json()).then((data) => this.populate(data)).catch((error) => this.fail);
        }

        this.analyticsPush(e, 'select_address');
    }

    analyticsPush(e, type) {

        let clickText = e?.target?.textContent.trim() || '';
        let event = ''
        let eventAction = ''

        if(type === 'find_address') {
            event = 'find_address';
            eventAction = 'find address';
        } else if(type === 'select_address') {
            event = 'find_address_select';
            eventAction = 'address selected';
        }

        AnalyticsHelper.push({
            'event': `${event}`,
            'eventCategory': 'find address',
            'eventAction': `${eventAction}`,
            'eventLabel': `cars|find address|${clickText}|internal|middle|#`,
            'actionType': `${eventAction}`,
            'businessUnit' : 'cars',
            'moduleName': 'find address',
            'clickText': `${clickText}`,
            'clickType': 'internal', 
            'destinationURL': '#',
            'inPageLocation': 'middle'
        });
    }

    populate(data) {
        if (this.mode === 'standard') {            
            const address = this.field('address');            
            const city = this.field('city');            
            const postcode = this.field('postcode');

            const addressParts = [data.organisation, data.flatNumber, data.buildingName, `${data.propertyNumber} ${data.streetName}`].filter((a) => a);
            while(addressParts.join(', ').length > 60){
                addressParts.shift();
            }
            address.inputs[0].el.value = addressParts.join(', ');
            city.inputs[0].el.value = data.city;
            postcode.inputs[0].el.value = data.postcode;
        } else if (this.mode === 'custom') {            
            const buildingName = this.field('buildingName');
            const flatNumber = this.field('flatNumber');
            const propertyNumber = this.field('propertyNumber');
            const streetName = this.field('streetName');
            const city = this.field('city');
            const county = this.field('county');
            const postcode = this.field('postcode');

            if(buildingName) { buildingName.inputs[0].el.value = [data.organisation, data.buildingName].filter((s)=>s).join(', '); }
            if(flatNumber) { flatNumber.inputs[0].el.value = data.flatNumber; }
            if(propertyNumber) { propertyNumber.inputs[0].el.value = data.propertyNumber; }
            if(streetName) { streetName.inputs[0].el.value = [data.streetName, data.locality].filter((s)=>s).join(', '); }
            if(city) { city.inputs[0].el.value = data.city; }
            if(county) { county.inputs[0].el.value = data.county; }
            if(postcode) { postcode.inputs[0].el.value = data.postcode; }
        }

        this.valid().then((valid) => this.update(this, valid));
    }

    fail(r) {

    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_address_lookup');
    }
}
